<template>
  <div id="frota">
    <vue-headful :title="$store.state.option['car_title-' + lang]" :lang="lang" />
    <titulo></titulo>

    <div class="container">
      <div class="row p-v-20">
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 box" v-for="(dt, index) in res" :key="index">
          <div class="card float-left p-0 m-0 full-width">
            <div style="height:190px; line-height:190px;text-align:center;">
              <img :src="dt.imageURL ? dt.imageURL : '/img/img.png'" class="card-img-top" :alt="dt.brand + ' ' + dt.model" />
            </div>
            <div class="card-body text-center">
              <h5 class="card-title m-0">{{dt.brand}} {{dt.model}}</h5>
              <p class="card-text">{{dt.group_Name}}</p>

              <div class="text-center p-t-5">
                <span class="car-icon bg-icon_driver">{{dt.seats}}</span>
                <span class="car-icon bg-icon_door">{{dt.doors}}</span>
                <span class="car-icon bg-icon_bag">{{dt.suitcases}}</span>
                <span class="car-icon bg-icon_transmissao text-uppercase" v-if="dt.automaticTransmission">{{$store.state.option['automatic-' + lang][0]}}</span>
              <span class="car-icon bg-icon_transmissao text-uppercase" v-else>{{$store.state.option['manual-' + lang][0]}}</span>
              </div>

              <div class="clearfix m-t-10"></div>
              <router-link class="btn btn-primary btn-block text-uppercase box-a" to="/reserved">{{$store.state.option['car_reservar-' + lang]}} <i class="far fa-check-circle"></i></router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import titulo from '@/components/titulo'

export default {
  components: { titulo },
  data () {
    return {
      res: [],
      lang: ''
    }
  },
  mounted () {
    this.SET_LOAD(true)
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_LOAD',
      'SET_TITULO',
      'SET_SUBTITULO'
    ]),
    init () {
      if (this.$store.state.option1 && this.$store.state.cars1) {
        this.res = this.$store.state.cars
        this.lang = this.$store.state.lang
        this.SET_TITULO(this.$store.state.option['car_title-' + this.lang])
        this.SET_SUBTITULO(this.$store.state.option['car_subtitle-' + this.lang])
        this.SET_LOAD()
      } else {
        this._.delay(this.init, 100)
      }
    }
  }
}
</script>
